import React from 'react';
import { motion } from 'framer-motion';

const features = [
  {
    title: 'Proven Experience',
    description: 'Over 25 years of expertise in commercial flooring solutions. We\'ve partnered with Fortune 500 retailers, grocery chains, and chain store flooring programs to deliver entrance mat systems, grid systems, and floor protection that stand the test of time.',
    image: '/Assets/images/01_Homepage/feature_proven-experience.jpg'
  },
  {
    title: 'Cost Savings',
    description: 'Engineered for slip and fall prevention, comfort at work, and reduced lifecycle costs. Our entry tiles and entrance systems capture soil and moisture before it ever reaches your interior.',
    image: '/Assets/images/01_Homepage/feature_cost-savings.jpg'
  },
  {
    title: 'Trusted Partner',
    description: '500+ industry partners rely on our installation services nationwide. From consultation to national flooring rollouts, our retail flooring installation crews are with you every step of the way.',
    image: '/Assets/images/01_Homepage/feature_trusted-partner.jpg'
  }
];

export const WhyPorticoSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-portico">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why Portico Systems?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We don't just sell flooring—we build partnerships that last.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="card-portico-elevated overflow-hidden h-full flex flex-col">
                {/* Feature Image */}
                <div className="h-48 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-smooth"
                  />
                </div>
                {/* Content */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="font-heading font-semibold text-xl mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground flex-grow">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPorticoSection;
